import axios from 'axios';
import { Mode, downloadCsvUrl, paymentDetailUrl, paymentsUrl, retriggerWebhookUrl } from '../../../shared/helpers/endPoints';
import { getStoreLocal } from '../../../shared/helpers/utils';
import { authService } from '../../users/services/dependency.injection';
import { env } from '../../../config/env';
import { IAllPaymentData, IContent } from '../models/allPayments.model';
import { APIResponse } from '../../../shared/infrastructure/services/api.response';
import { Result } from '../../../shared/core/result';
import { Left, Right } from '../../../shared/core/either';
import { FilterTransactionDto } from '../dtos/transaction.dto';
import { BaseTransactionService } from './base_transaction.service';

export default class TransactionService implements BaseTransactionService {

    public async getAllPayment(value: FilterTransactionDto): Promise<APIResponse<IAllPaymentData>> {
        try {
            const modeType = getStoreLocal('modeType') as Mode;

            const response = await axios({
                method: 'GET',
                url: paymentsUrl(modeType),
                params: { ...value },
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authService.accessToken()}` }
            });

            return new Right(Result.ok<IAllPaymentData>(response.data));
        } catch (error) {
            const message = error?.data?.error?.message;
            const errorMessage = message !== undefined ? message : "Something went wrong"
            return new Left(errorMessage);
        }
    }

    public async getPaymentById(id: string): Promise<APIResponse<IContent>> {
        try {
            const modeType = getStoreLocal('modeType') as Mode;

            const response = await axios({
                method: 'GET',
                url: paymentDetailUrl(modeType, id),
                params: {},
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authService.accessToken()}` }
            });

            return new Right(Result.ok<IContent>(response.data));
        } catch (error) {
            const message = error?.data?.error?.message;
            const errorMessage = message !== undefined ? message : "Something went wrong"
            return new Left(errorMessage);
        }
    }

    public async downloadTransactionCsv(value: FilterTransactionDto): Promise<APIResponse<any>> {
        try {
            const modeType = getStoreLocal('modeType') as Mode;

            const response = await axios({
                method: 'GET',
                url: downloadCsvUrl(modeType),
                params: value,
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`,
                    'Content-Type': 'application/ms-excel',
                }
            });

            return new Right(Result.ok(response.data));
        } catch (error: any) {
            const message = error?.data?.error?.message;
            const errorMessage = message !== undefined ? message : "Something went wrong"
            return new Left(errorMessage);
        }
    }

    public async retriggerWebhook(reference: string, tag: string, apiKey?: string): Promise<APIResponse<any>> {
        try {
            const modeType = getStoreLocal('modeType') as Mode;
            const key = apiKey || env.REACT_APP_SPAY_SETTLEMENT_CD;

            const response = await axios({
                method: 'GET',
                url: retriggerWebhookUrl(modeType, reference, tag),
                headers: {
                    Authorization: `Bearer ${authService.accessToken()}`,
                    'api-key': key,
                    'Content-Type': 'application/json'
                }
            });

            return new Right(Result.ok(response.data));
        } catch (error: any) {
            const message =
                error?.response?.data?.error?.message ||
                error?.response?.data?.message ||
                error?.data?.error?.message ||
                error?.message ||
                'Failed to retrigger webhook';
            return new Left(message);
        }
    }
}
